// clarityReady.js
let clarityReadyPromise;

export function clarityReady() {
  if (!clarityReadyPromise) {
    clarityReadyPromise = new Promise((resolve) => {
      const check = () => {
        if (typeof window.clarity === "function") {
          resolve(window.clarity);
        } else {
          setTimeout(check, 50);
        }
      };
      check();
    });
  }
  return clarityReadyPromise;
}

export const trackClarityEvent = async (eventName, payload = {}) => {
  if (typeof window === "undefined") return;

  const clarity = await clarityReady();

  console.log("Event sent", eventName)

  clarity("event", eventName, {
    ...payload,
    timestamp: Date.now(),
  });
};